import { render } from "./accommodations.vue?vue&type=template&id=0c277ab2&scoped=true"
import script from "./accommodations.vue?vue&type=script&lang=js"
export * from "./accommodations.vue?vue&type=script&lang=js"

import "./accommodations.vue?vue&type=style&index=0&id=0c277ab2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c277ab2"]])

export default __exports__